var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nft"
  }, [_c('div', {
    staticClass: "nft-body"
  }, [_c('div', {
    staticClass: "nft-bg",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/nft-bg.jpg')}) center top/100% auto`
    }
  }), _c('div', {
    staticClass: "nft-main"
  }, [_c('div', {
    staticClass: "nft-shard"
  }, [_c('div', {
    staticClass: "nft-shard__title"
  }, [_vm._v("NFT SHARDS")]), _c('div', {
    staticClass: "nft-ship"
  }, [_c('div', {
    staticClass: "nft-ship-img"
  }, [_c('img', {
    staticClass: "ship",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/icon-ship.png'),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "light",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/light.png'),
      "alt": ""
    }
  })]), _vm._m(0)])]), _c('div', {
    staticClass: "nft-menu"
  }, [_vm._m(1), _c('div', {
    staticClass: "nft-menu-main"
  }, [_c('div', {
    staticClass: "nft-menu-list"
  }, _vm._l(_vm.nftMenu, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "nft-menu-item",
      on: {
        "click": function ($event) {
          return _vm.onMenu(item);
        }
      }
    }, [_c('div', {
      staticClass: "nft-menu-item__icon"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "nft-menu-item__label"
    }, [_vm._v(_vm._s(item.label))])]);
  }), 0)])]), _c('div', {
    staticClass: "nft-my"
  }, [_c('div', {
    staticClass: "nft-my__title"
  }, [_vm._v("My NFT")]), _c('div', {
    staticClass: "nft-my-list"
  }, _vm._l(9, function (item, index) {
    return _c('div', {
      staticClass: "nft-my-item"
    }, [_vm._m(2, true), _c('div', {
      staticClass: "nft-my-item__label"
    }, [_vm._v("Precious Peach #2465")])]);
  }), 0)])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nft-btns"
  }, [_c('div', {
    staticClass: "btn-craft"
  }, [_vm._v("Craft an NFT")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nft-menu__title"
  }, [_c('span', [_vm._v("Get NFT Shards")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nft-my-item__img"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })]);
}];
export { render, staticRenderFns };